import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/close.svg'
import _imports_1 from '@/assets/img/eye-view.svg'
import _imports_2 from '@/assets/img/view-streamline.svg'
import _imports_3 from '@/assets/img/view-off-streamline.svg'


const _withScopeId = n => (_pushScopeId("data-v-1d2cc4c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "modal-body account-modal" }
const _hoisted_6 = { class: "modal-body-sec1" }
const _hoisted_7 = { class: "password-group" }
const _hoisted_8 = {
  for: "secret",
  class: "control-label input-label-password"
}
const _hoisted_9 = { class: "password-sec" }
const _hoisted_10 = ["placeholder", "onKeyup"]
const _hoisted_11 = {
  for: "id",
  class: "control-label input-label-password"
}
const _hoisted_12 = { class: "password-sec" }
const _hoisted_13 = ["type", "placeholder", "onKeyup"]
const _hoisted_14 = {
  key: 0,
  class: "tw-h-[40px]",
  src: _imports_1
}
const _hoisted_15 = {
  key: 1,
  class: "tw-h-[40px]",
  src: _imports_2
}
const _hoisted_16 = {
  key: 2,
  class: "tw-h-[40px] tw-mb-[2px]",
  src: _imports_3
}
const _hoisted_17 = { class: "password-text" }
const _hoisted_18 = { class: "password-text-sec1" }
const _hoisted_19 = { class: "row password-conditions mt-2" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "p-0 password-left-conditions" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "p-0" }
const _hoisted_24 = { class: "create-acc-btn" }
const _hoisted_25 = ["disabled"]

import errorhandler from "@/components/common/exceptionHandler.vue";
import Utils, { passwordHash } from "@/utils/utilities";
import { load } from "recaptcha-v3";
// import VRuntimeTemplate from "vue3-runtime-template";
import store from "@/store";
import {
  localStorageBoolean,
  localStorageKey,
  sessionStorageKeys,
} from "@/utils/constants";
import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
  onBeforeMount,
} from "vue";
import router from "@/router";
import userService from "@/services/user/userService";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'resetPasswordContain',
  setup(__props) {

// import $ from "jquery";
const route = useRoute();

const disableButton = ref(true);
const showPassword = ref(true);
const enable_showpassword = ref(false);
const showResetPasswordCallbackError = ref(false);
const resetPasswordCallbackErrorMsg = ref("");

const newPasswordPlaceholder = ref("");
const secretPlaceholder = ref("");
const footerText = ref("");
const createaccountModal = ref<null>(null);
const footerTextTags: any = {
  "user-create-button-create-account-1": {
    openTag: "<strong>",
    closeTag: "</strong>",
  },
  "user-create-footer-link-tc-1": {
    openTag: '<a href="javascript:void(0)">',
    closeTag: "</a>",
  },
  "user-create-footer-link-pp-1": {
    openTag: '<a href="javascript:void(0)">',
    closeTag: "</a>",
  },
};

const secretDisabled = computed(() => route.query.secretDisabled === "false");

const languageSelected = computed(
  () => store.state.LanguagePicker.languageSelected,
);
const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);
const password = ref("");
const secret = ref("");
const passwordFieldType = ref("password");

const getUiText = (id: string, isArray = false) => {
  return Utils.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const getProcessedUIText = (id: string, tags: any) => {
  return Utils.getProcessedUIText(
    id,
    tags,
    languageSelectedText.value,
    defaultUiText.value,
  );
};

const updateUIVariables = () => {
  newPasswordPlaceholder.value = getUiText(
    "user-reset-password-new-password-heading",
  );
  secretPlaceholder.value = getUiText("user-reset-password-secret-heading");

  footerText.value =
    "<span>" +
    getProcessedUIText("user-create-footer-text-1", footerTextTags) +
    "</span>";
};

const onResize = () => {
  password.value && password.value.focus();
};

const passwordIV = computed(() => store.state.LanguagePicker.pwdFeIv);

const setLanguages = async () => {
  if (
    localStorage.getItem(localStorageKey.languagesData) == null ||
    localStorage.getItem(localStorageKey.languageList) == null ||
    passwordIV.value === ""
  ) {
    await Utils.getV3Recaptcha().then(
      async (finalKey: any) => {
        const captchKey = finalKey;
        const recaptcha = await load(`${captchKey}`, {
          autoHideBadge: true,
        });
        recaptcha.execute("submit").then((token) => {
          localStorage.setItem(localStorageKey.recaptcha, token);
          store.dispatch("LanguagePicker/setLanguages", token);
        });
        recaptcha.execute("submit").then((token) => {
          localStorage.setItem(localStorageKey.recaptcha, token);
          store.dispatch("LanguagePicker/setLanguageList", token);
        });
      },
      (error: any) => {
        if (error && error.data && error.data.error && error.data.error.type) {
          if (error.data.error.type === "exc_session_invalid-1") {
            sessionStorage.setItem(
              "prospectCallbackErrorInfo",
              JSON.stringify(error.data.error),
            );
            router.push({ path: "/" });
          } else {
            showErrorInfo(error.data.error);
          }
        } else if (error.data.message === "invalid csrf token") {
          sessionStorage.setItem(
            "prospectCallbackErrorInfo",
            JSON.stringify(error.data),
          );
          router.push({ path: "/" });
        } else {
          showErrorInfo(error.data);
        }
      },
    );
  }
};

onMounted(() => {
  nextTick(() => {
    window.addEventListener("resize", onResize);
    onResize();
  });
  const bodyElement = document.querySelector("body");

  if (bodyElement && !bodyElement.classList.contains("page-opacity")) {
    bodyElement.classList.add("page-opacity", "page-bg");
  }
  document.getElementById("createaccountModal")?.classList.add("show");
  updateUIVariables();
  setLanguages();
  if (!sessionStorage.getItem(sessionStorageKeys.passwordResetToken)) {
    sessionStorage.setItem(
      "prospectCallbackErrorInfo",
      JSON.stringify({
        message: getUiText("user-reset-password-token-error"),
      }),
    );
    router.push({ path: "/" });
  }
  keyMonitor();
});

const showErrorInfo = (errorInfo: any) => {
  if (errorInfo && errorInfo !== "") {
    errorInfo =
      typeof errorInfo === "string" ? JSON.parse(errorInfo) : errorInfo;
    if (errorInfo && Object.keys(errorInfo).length > 0 && errorInfo.message) {
      showResetPasswordCallbackError.value = true;
      resetPasswordCallbackErrorMsg.value = errorInfo.message;
    }
  }
};

const keyMonitor = () => {
  const passwordField: any = document.getElementById("psw");
  if (!passwordField) return;
  enable_showpassword.value = passwordField.value.length > 0 ? true : false;

  const secretField: any = document.getElementById("secret");
  const secretFieldHasValue: boolean = secretDisabled.value
    ? secretField.value.length > 0
      ? true
      : false
    : true;

  let pattern = /(?=.*\d)(?=.*[a-z])(?=.*[!@#$%^&*])(?=.*[A-Z]).{8,}/g;
  if (secretFieldHasValue && passwordField.value.match(pattern)) {
    disableButton.value = false;
  } else {
    disableButton.value = true;
  }
};

const togglePassword = () => {
  if (!enable_showpassword.value) return;
  showPassword.value = !showPassword.value;

  passwordFieldType.value =
    password.value?.type === "password" ? "text" : "password";
};

const setRecaptchaInfo = async (captchaSiteKey: any) => {
  const captchKey = captchaSiteKey;
  const recaptcha = await load(`${captchKey}`);
  recaptcha.execute("submit").then((token) => {
    submit(token);
  });
  recaptcha.execute("submit").then((token) => {
    store.dispatch("LanguagePicker/setLanguages", token);
  });
  recaptcha.execute("submit").then((token) => {
    store.dispatch("LanguagePicker/setLanguageList", token);
  });
};

const submit = async (tokenRecaptcha: string) => {
  const passwordData = password.value?.value?.toString() ?? "";
  const secretData = secret.value?.value?.toString() ?? "";
  const token: string =
    sessionStorage.getItem(sessionStorageKeys.passwordResetToken)?.toString() ??
    "";
  await submitPassword(tokenRecaptcha, passwordData, secretData, token);
};

const submitPassword = async (
  tokenRecaptcha: string,
  password: string,
  secret: string,
  token: string,
) => {
  try {
    if (!password || !secret || !token) {
      showErrorInfo({
        message: getUiText("user-reset-password-token-error"),
      });
      return;
    }

    const passwordValue = await passwordHash(password, passwordIV.value);

    if (secretDisabled.value) {
      await userService.resetPassword(
        token,
        `%s${passwordIV.value}.${passwordValue}`,
        tokenRecaptcha,
        secret,
      );
    } else {
      await userService.resetPassword(
        token,
        `%s${passwordIV.value}.${passwordValue}`,
        tokenRecaptcha,
      );
    }
    localStorage.removeItem("csrfReloadDone");
    router.push({ path: "/user/login" });
  } catch (error: any) {
    if (error && error.data && error.data.error && error.data.error.type) {
      if (error.data.error.type === "exc_session_invalid-1") {
        sessionStorage.setItem(
          "prospectCallbackErrorInfo",
          JSON.stringify(error.data.error),
        );
        router.push({ path: "/" });
      } else {
        showErrorInfo(error.data.error);
      }
    } else if (error.data.message === "invalid csrf token") {
      if (localStorage.getItem("csrfReloadDone") == null) {
        localStorage.setItem("csrfReloadDone", localStorageBoolean.true);
        router.go(0);
      }
      sessionStorage.setItem(
        "prospectCallbackErrorInfo",
        JSON.stringify(error.data),
      );
      router.push({ path: "/" });
    } else {
      showErrorInfo(error.data);
    }
  }
};

const getV3Recaptcha = () => {
  if (disableButton.value) {
    return;
  }
  Utils.getV3Recaptcha().then(
    (finalKey: any) => {
      setRecaptchaInfo(finalKey);
    },
    (error: any) => {
      if (
        error &&
        error.status &&
        error.data &&
        error.data.error &&
        error.data.error.message
      ) {
        showErrorInfo(error.data.error);
      } else if (error.data.message.toLowerCase() === "invalid csrf token") {
        router.go(0);
      } else {
        showErrorInfo(error.data);
      }
    },
  );
};

const onClickClose = () => {
  sessionStorage.removeItem(sessionStorageKeys.passwordResetToken);
  router.push({ path: "/user/forgotPassword" });
};

const resetShowResetPasswordCallbackError = () => {
  showResetPasswordCallbackError.value = false;
  resetPasswordCallbackErrorMsg.value = "";
};

watch(
  () => languageSelected.value,
  () => {
    setTimeout(() => {
      updateUIVariables();
    }, 50);
  },
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showResetPasswordCallbackError.value || null)
      ? (_openBlock(), _createBlock(errorhandler, {
          key: 0,
          "prospect-callback-error-msg": resetPasswordCallbackErrorMsg.value,
          onResetShowProspectCallbackError: resetShowResetPasswordCallbackError
        }, null, 8, ["prospect-callback-error-msg"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: "createaccountModal",
      ref_key: "createaccountModal",
      ref: createaccountModal,
      class: "modal fade create-account-modal tw-block",
      role: "dialog",
      "aria-labelledby": "responseModalLabel",
      "data-backdrop": "false"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "aria-label": "Close",
              onClick: onClickClose
            }, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(getUiText("user-reset-password-heading")), 1),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_8, _toDisplayString(getUiText("user-reset-password-secret-heading")), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("input", {
                    id: "secret",
                    ref_key: "secret",
                    ref: secret,
                    "data-cy": "reset-password-page-email-input",
                    type: "text",
                    class: "form-control form-control-lg password-input",
                    placeholder: secretPlaceholder.value,
                    tabindex: "0",
                    onKeyup: [
                      _withKeys(getV3Recaptcha, ["enter"]),
                      keyMonitor
                    ]
                  }, null, 40, _hoisted_10)
                ])
              ], 512), [
                [_vShow, secretDisabled.value]
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(getUiText("user-reset-password-new-password-heading")), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("input", {
                    id: "psw",
                    ref_key: "password",
                    ref: password,
                    "data-cy": "reset-password-page-password-input",
                    type: passwordFieldType.value,
                    class: "form-control form-control-lg password-input",
                    placeholder: newPasswordPlaceholder.value,
                    tabindex: "0",
                    onKeyup: [
                      _withKeys(getV3Recaptcha, ["enter"]),
                      keyMonitor
                    ]
                  }, null, 40, _hoisted_13),
                  _createElementVNode("span", {
                    tabindex: "0",
                    class: "show-password pr-3 tw-ml-[10px]",
                    onClick: togglePassword
                  }, [
                    (!enable_showpassword.value || null)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                      : (enable_showpassword.value && showPassword.value)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                        : (enable_showpassword.value && !showPassword.value)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                          : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      class: _normalizeClass(["show-password-label", enable_showpassword.value ? 'enabled' : 'disabled'])
                    }, _toDisplayString(showPassword.value
                        ? getUiText("app-user-login-password-show-1")
                        : getUiText("app-user-login-password-hide-1")), 3)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(getUiText("user-create-guidance-heading-1")), 1),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("ul", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getUiText(
                      'user-create-guidance-text-1',
                      true,
                    ), (item) => {
                      return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("ul", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getUiText(
                      'user-create-guidance-text-2',
                      true,
                    ), (item) => {
                      return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", {
                type: "button",
                "data-cy": "reset-password-page-submit-button",
                class: "btn btn-primary getstarted-button",
                disabled: disableButton.value,
                onClick: getV3Recaptcha
              }, _toDisplayString(getUiText("user-reset-password-btn")), 9, _hoisted_25)
            ])
          ])
        ])
      ])
    ], 512)
  ], 64))
}
}

})